import React, { useState } from 'react';
import './currentWorkouts.css';
import { contextAction, currentSubscriptionAction, keyNumberAction } from "../../redux/rootReducer";
import { useDispatch, useSelector } from "react-redux";
import { changeWorkoutDateSagaAction, removeWorkoutSagaAction, saveKeyNumberSagaAction } from "../../redux/sagaActions";
import ContextMenu from "../ContextMenu/ContextMenu";
import { CURRENT_SUBSCRIPTION_INITIAL } from "../../redux/initialStateConstant";
import { useLocation } from 'react-router-dom';
import CalendarOffline from "../CalendarOffline/CalendarOffline";

const CurrentWorkouts = () => {
    const location = useLocation();

    const dispatch = useDispatch();
    const current_subscription = useSelector(state => state.current_subscription);
    const key_number = useSelector(state => state.key_number);
    const context = useSelector(state => state.context);

    // Состояние открытого календаря
    const [changeWorkoutDateCalendar, setChangeWorkoutDateCalendar] = useState(null);

    let data = null;
    if (current_subscription.current_workouts?.length  && context) {
        data = current_subscription.current_workouts.find(elem => elem.id === context);
    }

    const menu = [
        {
            id: '1',
            caption: 'Удалить тренировку',
            handler: () => {
                if (window.confirm('Вы действительно хотите удалить тренировку?')) {
                    dispatch(removeWorkoutSagaAction({
                        workout_id: data.id,
                        location: location.pathname
                    }));
                }
                dispatch(contextAction(false));
            }
        }
    ];

    return (
        <div className="page__content">
            <div className="table__header">
                <div className="table__caption">{ `Список тренировок ${ current_subscription.count }` }</div>
                <div className="user__back"
                     onClick={ () => {
                         dispatch(currentSubscriptionAction(CURRENT_SUBSCRIPTION_INITIAL));
                     } }
                >Назад</div>
            </div>
            <div className="table">
                <div className="table__row table__row--header workouts__row">
                    <div className="table__cell table__cell--left">Имя</div>
                    <div className="table__cell">Тип тренировки</div>
                    <div className="table__cell">Дата</div>
                    <div className="table__cell">Начало тренировки</div>
                    <div className="table__cell">Конец тренировки</div>
                    <div className="table__cell">Номер ключа</div>
                </div>
                {
                    current_subscription.current_workouts.map(elem => {
                        return (
                            <div key={ elem.id } className="table__row workouts__row">
                                <ContextMenu data={{
                                    open: elem.id === context,
                                    style: { right: 28 },
                                    menu
                                }}/>
                                <div className="table__cell table__cell--left">{ elem.user }</div>
                                <div className="table__cell">{ elem.type }</div>
                                <div className="table__cell table__cell--hover table__cell--no-overflow"
                                     onClick={ event => {
                                         event.preventDefault();
                                         event.stopPropagation();
                                         if (event.target.closest('.calend')) return;
                                         setChangeWorkoutDateCalendar(elem.id);
                                     } }
                                >
                                    <CalendarOffline
                                        date={ elem.date_not_formatted }
                                        handler={ date => {
                                            setChangeWorkoutDateCalendar(null);
                                            dispatch(changeWorkoutDateSagaAction({
                                                workout_id: elem.id,
                                                date,
                                                subscription_id: current_subscription.subscription_id,
                                                page: 'current_user'
                                            }));
                                        } }
                                        open={ changeWorkoutDateCalendar === elem.id }
                                        close={ () => setChangeWorkoutDateCalendar(null) }
                                        style={{ margin: '34px auto 0 auto', left: 0, right: 0 }}
                                    />
                                    { elem.date }
                                </div>
                                <div className="table__cell">{ elem.start }</div>
                                <div className="table__cell">{ elem.finish }</div>
                                <input type="text" className="table__cell input input--cell"
                                       value={ key_number.workout_id === elem.id ? key_number.number : elem.key_number }
                                       onInput={ event => dispatch(keyNumberAction({
                                           ...key_number,
                                           workout_id: elem.id,
                                           number: event.target.value,
                                       })) }
                                       onBlur={ () => {
                                           // Сохраняем номер ключа, только если было изменение номера
                                           if (key_number.workout_id) {
                                               dispatch(saveKeyNumberSagaAction({
                                                   key_number: key_number.number,
                                                   workout_id: key_number.workout_id,
                                                   update: 'current_user_subscription'
                                               }));
                                           }
                                       } }
                                />
                                <i className="menu__button" onClick={ event => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    dispatch(contextAction(elem.id));
                                } }/>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

export default CurrentWorkouts;